/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Shared_BackInputs */

const en_admin_shared_back = /** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const de_admin_shared_back = /** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const es_admin_shared_back = /** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`atrás`)
};

const fr_admin_shared_back = /** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

/** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */
const it_admin_shared_back = en_admin_shared_back;

/** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */
const pt_br2_admin_shared_back = en_admin_shared_back;

/** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */
const pl_admin_shared_back = en_admin_shared_back;

/** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */
const hu_admin_shared_back = en_admin_shared_back;

/** @type {(inputs: Admin_Shared_BackInputs) => LocalizedString} */
const ro_admin_shared_back = en_admin_shared_back;

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Admin_Shared_BackInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_back = /** @type {((inputs?: Admin_Shared_BackInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_BackInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_back(inputs)
	if (locale === "de") return de_admin_shared_back(inputs)
	if (locale === "es") return es_admin_shared_back(inputs)
	if (locale === "fr") return fr_admin_shared_back(inputs)
	if (locale === "it") return it_admin_shared_back(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_back(inputs)
	if (locale === "pl") return pl_admin_shared_back(inputs)
	if (locale === "hu") return hu_admin_shared_back(inputs)
	return ro_admin_shared_back(inputs)
});
export { admin_shared_back as "admin.shared.back" }